<template>
  <VTooltip v-if="breakdown?.total" theme="info-tooltip" class="block min-w-28">
    <div class="flex h-1.5 w-full overflow-hidden rounded-full bg-gray-100">
      <div
        v-for="category in categories"
        :key="category.category"
        :class="category.colors.bar"
        :style="{ width: `${category.share}%` }"
      />
    </div>
    <div class="mt-1 flex justify-between gap-2 text-xs tabular-nums">
      <span v-for="category in categories" :key="category.category" class="font-semibold" :class="category.colors.text">
        {{ category.share }} %
      </span>
    </div>
    <template #popper>
      <div class="space-y-1 text-xs">
        <div v-for="category in categories" :key="category.category" class="flex items-center gap-2">
          <span class="size-2 rounded-full" :class="category.colors.bar" />
          {{ t("category", { name: category.label, count: category.count, share: category.share }) }}
        </div>
      </div>
    </template>
  </VTooltip>
  <span v-else class="block text-right text-gray-400">—</span>
</template>

<script>
import { useI18n } from "vue-i18n";
import { categoryColors, sharesSummingTo100 } from "./grossSalesBreakdown";

export default {
  props: {
    breakdown: { type: Object, default: null },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    categories() {
      const offers = this.breakdown?.categories || [];
      const shares = sharesSummingTo100(
        offers.map((offer) => offer.count),
        this.breakdown?.total,
      );

      return offers.map((offer, index) => ({
        ...offer,
        label: this.t(`contract_distributions.category.${offer.category}`),
        share: shares[index],
        colors: categoryColors(index),
      }));
    },
  },
};
</script>

<i18n src="./GrossSalesCategorySplit.i18n.json"></i18n>
